// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordForm":"ResetPassword_resetPasswordForm__UOsis"};